import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';

import LabelAndInputDate from '../common/form/labelAndInputDate';

import {
	setModoTela, initForm
} from './veiculoTipoActions';
import labelAndCheckbox from '../common/form/labelAndCheckbox';
import ColorUtils from '../common/colorUtils/ColorUtils';

class VeiculoTipoForm extends Component {

	state = {

	}

	componentWillMount() {

	}

	render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';



		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<Field
								name='nome'
								component={LabelAndInput}
								label='Nome' placeholder='Informe o nome'
								cols='12 12 12 12'
								readOnly={readOnly} />
														
							<Field
								name='carreta1'
								component={LabelAndCheckbox}
								label='Carreta 1' placeholder='Selecione'
								cols='12 6 2 1'
								readOnly={readOnly} />
								
							<Field
								name='carreta2'
								component={LabelAndCheckbox}
								label='Carreta 2' placeholder='Selecione'
								cols='12 6 2 1'
								readOnly={readOnly} />

						</Row>

						<Row>
							<Field	
								name='cor'
								component={LabelAndInput}
								label='Cor (exemplo: #ffffff)' placeholder='Informe'
								cols='12 6 3 2'
								readOnly={readOnly} />
							
							<div 
								style={{
									backgroundColor: this.props.formularioValues.cor || '#ffffff',
									color: ColorUtils.getCorFonte(this.props.formularioValues.cor || '#ffffff'),
									width: 38,
									height: 38,
									textAlign: 'center',
									paddingTop: 6,
									borderRadius: '50%',
									marginTop: 28,
									fontWeight: 'bold',
									borderColor: '#000000',
									borderStyle: 'solid'
								}}>
								Aa
							</div>
							
							<Grid cols='12 6 3 3' style={{ paddingTop: 38 }}>
								<a style={{ marginTop: 36 }} href='https://share.google/ce9IfHOBK6cEHikbY' target='blank'>Escolha a cor</a>
							</Grid>
						</Row>

					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
									<Button
										text='Salvar'
										submit
										type={'success'}
										icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		)
	}


}

VeiculoTipoForm = reduxForm({ form: 'veiculoTipoForm', destroyOnUnmount: false })(VeiculoTipoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioLogado: state.auth.usuarioLogado,
	formularioValues: getFormValues('veiculoTipoForm')(state),
	registro: state.veiculoTipo.registro,




});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(VeiculoTipoForm);
